//TODO: allow this to be customized
let initialState = 10;

let itemsPerPage = (state = initialState, action) => {
	switch (action.type) {
		default:
			return state;
	}
};

export default itemsPerPage;


/** WEBPACK FOOTER **
 ** C:/Users/Lewis/Develop/redux-data-table/app/reducers/items-per-page.js
 **/